import { jsx } from 'react/jsx-runtime';
import { Trigger, Content, Root } from '@radix-ui/react-collapsible';
import { twMerge } from 'tailwind-merge';
import css from './Collapsible.module.css.js';

Collapsible.Trigger = props => {
  return jsx(Trigger, {
    ...props,
    className: twMerge('cursor-pointer', props.className)
  });
};
Collapsible.Content = props => {
  return jsx(Content, {
    ...props,
    className: twMerge(css.content, props.className)
  });
};
function Collapsible({
  ...props
}) {
  return jsx(Root, {
    ...props
  });
}

export { Collapsible };
